

/* PHOS: all purchase prices come from Shopify Liquid allocations; never recompute a plan discount. */
(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const config = window.PHOS || {};
  const root = (config.root || '/').replace(/\/?$/, '/');
  const money = (cents, currency = config.currency || 'USD') => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:currency || config.currency || 'USD'}).format(cents / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const request = async (path, options = {}) => {
    const response = await fetch(root + path, {...options, headers:{Accept:'application/json', ...options.headers}});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to update your bag. Please try again.');
    return data;
  };
  const toast = message => {
    const el = $('[data-toast]'); if (!el) return;
    $('[data-toast-msg]').textContent = message; el.classList.add('show');
    clearTimeout(el.timer); el.timer = setTimeout(() => el.classList.remove('show'), 4500);
  };
  let lastFocus;
  const drawer = $('[data-cart-drawer]'), overlay = $('[data-cart-overlay]'), menu = $('[data-nav-mobile]');
  const closeCart = () => {
    if (!drawer) return;
    drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); drawer.inert = true;
    overlay?.classList.remove('open'); document.body.style.overflow = '';
    if (lastFocus?.isConnected) lastFocus.focus();

  };
  const openCart = () => {
    if (!drawer) {location.href = root + 'cart'; return;}
    lastFocus = document.activeElement; drawer.inert = false; drawer.classList.add('open'); drawer.setAttribute('aria-hidden','false');
    overlay?.classList.add('open'); document.body.style.overflow = 'hidden'; $('[data-cart-close]', drawer)?.focus();
  };
  const toggleMenu = open => {
    if (!menu) return;
    if (open) lastFocus = document.activeElement;
    menu.classList.toggle('open',open); menu.setAttribute('aria-hidden',String(!open)); menu.inert = !open;
    $('[data-nav-toggle]')?.setAttribute('aria-expanded',String(open)); document.body.style.overflow = open ? 'hidden' : '';
    if(open) $('[data-nav-close]',menu)?.focus(); else if(lastFocus?.isConnected) lastFocus.focus();
  };
  if(drawer) drawer.inert=true;
  if(menu) menu.inert=true;
  document.addEventListener('keydown', e => {
    const modal = drawer?.classList.contains('open') ? drawer : menu?.classList.contains('open') ? menu : null;
    if(e.key==='Escape' && modal) {if(drawer?.classList.contains('open'))closeCart();else toggleMenu(false);}
    if(e.key==='Tab' && modal){
      const items=$$('a[href],button:not([disabled]),input,select,[tabindex="0"]',modal).filter(el=>el.getClientRects().length);
      const first=items[0],last=items[items.length-1];
      if(e.shiftKey && document.activeElement===first){e.preventDefault();last?.focus();}
      else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first?.focus();}
    }
  });
  const renderCart = cart => {
    $$('[data-cart-count]').forEach(el=>el.textContent='('+cart.item_count+')');
    $$('[data-cart-count-text]').forEach(el=>el.textContent=cart.item_count+(cart.item_count===1?' item':' items'));
    $$('[data-cart-subtotal]').forEach(el=>el.textContent=money(cart.total_price,cart.currency));

    $$('[data-shipping-progress]').forEach(el=>{el.textContent=cart.currency==='USD'?(cart.total_price>=6000?'Your order qualifies for free U.S. shipping.':'Free U.S. shipping on orders of $60 or more.'):'';el.hidden=cart.currency!=='USD'||!cart.item_count;});
    const foot=$('[data-cart-foot]'); if(foot) foot.hidden=!cart.item_count;
    const body=$('[data-cart-body]'); if(!body) return;
    body.innerHTML=cart.item_count ? cart.items.map(item=>{
      const src=String(item.product_id)===String(config.productId) ? config.bottle : item.image;
      const plan=item.selling_plan_allocation?.selling_plan?.name || 'One-time purchase';
      const itemLink=new URL(item.url,location.origin);
      if(item.selling_plan_allocation){itemLink.searchParams.set('selling_plan',String(item.selling_plan_allocation.selling_plan.id));itemLink.searchParams.delete('purchase');}
      else{itemLink.searchParams.set('purchase','once');itemLink.searchParams.delete('selling_plan');}
      const itemUrl=itemLink.pathname+itemLink.search;
      return `<div class="cart-line"><a class="img" href="${escape(itemUrl)}"><img src="${escape(src)}" alt="${escape(item.product_title)}" width="80" height="112"></a><div class="cart-line-content"><h3><a href="${escape(itemUrl)}">${escape(item.product_title)}</a></h3><p class="meta">${escape(item.variant_title==='Default Title'?'':item.variant_title)} · ${escape(plan)}</p><p class="cart-set-label">Quantity in sets</p><div class="row"><div class="cart-qty"><button type="button" aria-label="Decrease sets of ${escape(item.product_title)}" data-cart-change="${escape(item.key)}" data-quantity="${item.quantity-1}">−</button><span>${item.quantity}</span><button type="button" aria-label="Increase sets of ${escape(item.product_title)}" data-cart-change="${escape(item.key)}" data-quantity="${item.quantity+1}">+</button></div><strong>${money(item.final_line_price,cart.currency)}</strong></div><button type="button" class="cart-rem" data-cart-change="${escape(item.key)}" data-quantity="0">Remove</button></div></div>`;
    }).join('') : `<div class="cart-empty"><p>Your ritual awaits.</p><a class="btn btn--primary" href="${root}products/moroccan-oil">Shop the oil ↗</a></div>`;
  };
  const syncCart = async () => {const cart=await request('cart.js'); renderCart(cart); return cart;};
  let cartBusy=false;
  document.addEventListener('click', async e=>{
    if(e.target.closest('[data-nav-toggle]')) toggleMenu(true);
    if(e.target.closest('[data-nav-close]') || e.target.closest('[data-nav-mobile] a')) toggleMenu(false);
    if(e.target.closest('[data-cart-open]')) {openCart(); syncCart().catch(err=>toast(err.message));}
    if(e.target.closest('[data-cart-close]') || e.target===overlay) closeCart();
    const button=e.target.closest('[data-cart-change]');
    if(!button || cartBusy) return;
    cartBusy=true; button.disabled=true;
    try{const cart=await request('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:button.dataset.cartChange,quantity:Number(button.dataset.quantity)})});renderCart(cart);if(document.body.classList.contains('template-cart')) location.reload();}
    catch(err){toast(err.message);button.disabled=false;}
    finally{cartBusy=false;}
  });
  function init(scope=document){
    $$('[data-ticker]',scope).forEach(ticker=>{

      if(ticker.dataset.ready)return;ticker.dataset.ready='true';
      $('[data-ticker-toggle]',ticker)?.addEventListener('click',e=>{const paused=ticker.classList.toggle('is-paused');e.currentTarget.setAttribute('aria-pressed',String(paused));e.currentTarget.setAttribute('aria-label',paused?'Resume scrolling text':'Pause scrolling text');});
    });
    $$('[data-ritual-guide]',scope).forEach(guide=>{
      if(guide.dataset.ready)return;guide.dataset.ready='true';
      const steps=$$('[data-ritual-step]',guide),photos=$$('[data-ritual-photo]',guide);
      const reduced=window.matchMedia('(prefers-reduced-motion: reduce)'),animations=new Map();
      let selected=steps.find(step=>step.open)||steps[0],guideWidth=0;
      if(!selected)return;
      photos.forEach(photo=>{photo.hidden=false;});
      const syncPhotos=()=>photos.forEach(photo=>{
        const active=photo.dataset.ritualPhoto===selected.dataset.ritualStep;
        photo.classList.toggle('is-active',active);photo.setAttribute('aria-hidden',String(!active));
      });
      // Equal panel space keeps the section and photograph steady between steps.
      const measure=()=>{
        const width=guide.getBoundingClientRect().width;
        if(Math.abs(width-guideWidth)<1)return;
        guideWidth=width;
        animations.forEach(animation=>animation.cancel());animations.clear();
        guide.style.removeProperty('--ritual-panel-height');
        steps.forEach(step=>{step.style.height='';step.open=true;});
        const height=Math.max(...steps.map(step=>step.querySelector('summary + div').getBoundingClientRect().height));
        guide.style.setProperty('--ritual-panel-height',`${height}px`);
        steps.forEach(step=>{step.open=step===selected;step.querySelector('summary').setAttribute('aria-expanded',String(step===selected));});
      };
      const select=step=>{
        if(step===selected)return;
        const heights=steps.map(item=>item.getBoundingClientRect().height);

        selected=step;syncPhotos();
        steps.forEach((item,index)=>{
          const active=item===selected,summary=item.querySelector('summary'),panel=item.querySelector('summary + div');
          animations.get(item)?.cancel();animations.delete(item);
          summary.setAttribute('aria-expanded',String(active));
          item.style.height='';item.open=true;
          const border=item.getBoundingClientRect().height-summary.getBoundingClientRect().height-panel.getBoundingClientRect().height;
          const end=summary.getBoundingClientRect().height+(active?panel.getBoundingClientRect().height:0)+border;
          if(reduced.matches||Math.abs(heights[index]-end)<1){item.open=active;return;}
          item.style.height=`${end}px`;
          const animation=item.animate([{height:`${heights[index]}px`},{height:`${end}px`}],{duration:320,easing:'cubic-bezier(.22,1,.36,1)'});
          animations.set(item,animation);
          animation.onfinish=()=>{if(animations.get(item)!==animation)return;item.open=active;item.style.height='';animations.delete(item);};
        });
      };
      steps.forEach(step=>step.querySelector('summary').addEventListener('click',event=>{event.preventDefault();select(step);}));
      syncPhotos();measure();
      new ResizeObserver(measure).observe(guide);
      document.fonts?.ready.then(()=>{guideWidth=0;measure();});
      // Load the complete photo sequence before a visitor starts switching steps.
      const preload=new IntersectionObserver(entries=>{if(!entries.some(entry=>entry.isIntersecting))return;photos.forEach(photo=>{const image=photo.querySelector('img');if(image)image.loading='eager';});preload.disconnect();},{rootMargin:'600px'});
      preload.observe(guide);
    });
    $$('[data-reviews-carousel]',scope).forEach(section=>{
      if(section.dataset.ready)return;section.dataset.ready='true';
      const viewport=$('[data-review-viewport]',section),groups=$$('[data-review-group]',section);
      const cards=$$('.phos-review-card',groups[0]),total=cards.length;
      if(total<2)return;
      const reduced=matchMedia('(prefers-reduced-motion: reduce)'),play=$('[data-review-play]',section);

      let userPaused=section.dataset.autoplay!=='true'||reduced.matches,hovered=false,focused=false,visible=false;
      let loopWidth=0,stepWidth=0,frame=0,previousTime=0,position=0,settleTimer,navigationTarget=null;
      groups[1].hidden=false;$('[data-review-controls]',section).hidden=false;
      const updateControl=()=>{
        play.setAttribute('aria-pressed',String(userPaused));play.setAttribute('aria-label',userPaused?'Resume scrolling reviews':'Pause scrolling reviews');
        $('[data-review-play-label]',play).textContent=userPaused?'Play':'Pause';
        $('[data-review-play-icon]',play).textContent=userPaused?'▷':'Ⅱ';
      };
      const normalize=()=>{if(loopWidth&&viewport.scrollLeft>=loopWidth)viewport.scrollLeft-=loopWidth;};
      const updateCount=()=>{
        const index=stepWidth?Math.round(viewport.scrollLeft/stepWidth)%total:0;
        $('[data-review-count]',section).textContent=`${String(index+1).padStart(2,'0')} / ${String(total).padStart(2,'0')}`;
      };
      const measure=()=>{
        const index=stepWidth?viewport.scrollLeft/stepWidth:0;
        loopWidth=groups[0].getBoundingClientRect().width;stepWidth=loopWidth/total;
        viewport.scrollLeft=(index%total)*stepWidth;position=viewport.scrollLeft;updateCount();
      };
      const tick=time=>{
        frame=0;
        if(!section.isConnected||!visible||document.hidden||userPaused||hovered||focused||reduced.matches){previousTime=0;return;}
        if(!document.querySelector('dialog[open],[data-cart-drawer].open,.nav-mobile.open')){
          const elapsed=previousTime?Math.min(time-previousTime,48):0;
          position+=elapsed*.028;if(loopWidth&&position>=loopWidth)position-=loopWidth;viewport.scrollLeft=position;
        }
        previousTime=time;frame=requestAnimationFrame(tick);
      };
      const wake=()=>{if(!frame&&section.isConnected){previousTime=0;position=viewport.scrollLeft;frame=requestAnimationFrame(tick);}};
      const pause=()=>{userPaused=true;updateControl();};

      const move=direction=>{
        pause();normalize();
        let current=navigationTarget??Math.round(viewport.scrollLeft/stepWidth),next=current+direction;
        if(next<0){viewport.scrollLeft+=loopWidth;next=total-1;}
        if(next>total){viewport.scrollLeft-=loopWidth;next=1;}
        navigationTarget=next;
        viewport.scrollTo({left:next*stepWidth,behavior:reduced.matches?'instant':'smooth'});
        const index=((next%total)+total)%total;
        $('[data-review-status]',section).textContent=`Review ${index+1} of ${total}`;
      };
      $('[data-review-prev]',section).addEventListener('click',()=>move(-1));
      $('[data-review-next]',section).addEventListener('click',()=>move(1));
      play.disabled=reduced.matches;
      play.addEventListener('click',()=>{userPaused=!userPaused;updateControl();wake();});
      viewport.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
      viewport.addEventListener('pointerdown',pause,{passive:true});
      viewport.addEventListener('wheel',event=>{if(Math.abs(event.deltaX)>0)pause();},{passive:true});
      viewport.addEventListener('scroll',()=>{updateCount();clearTimeout(settleTimer);settleTimer=setTimeout(()=>{normalize();navigationTarget=null;},180);},{passive:true});
      viewport.addEventListener('mouseenter',()=>{hovered=true;});viewport.addEventListener('mouseleave',()=>{hovered=false;wake();});
      viewport.addEventListener('focusin',()=>{focused=true;});viewport.addEventListener('focusout',()=>{focused=false;wake();});
      document.addEventListener('visibilitychange',wake);
      reduced.addEventListener('change',()=>{play.disabled=reduced.matches;if(reduced.matches)pause();wake();});
      new ResizeObserver(measure).observe(viewport);
      const observer=new IntersectionObserver(entries=>{visible=entries.some(entry=>entry.isIntersecting);wake();},{threshold:.05});observer.observe(section);
      section.addEventListener('shopify:section:unload',()=>{cancelAnimationFrame(frame);clearTimeout(settleTimer);observer.disconnect();});
      updateControl();measure();
    });
    $$('[data-purchase-form]',scope).forEach(form=>{
      if(form.dataset.ready) return; form.dataset.ready='true';

      const data=JSON.parse($('[data-purchase-data]',form).textContent), variants=data.variants;
      const variantInput=$('[data-variant-input]',form), planInput=$('[data-plan-input]',form), qty=$('[data-quantity]',form), submit=$('button[type="submit"]',form);
      let variant, price, busy=false;
      const update=()=>{
        variant=variants.find(v=>String(v.id)===variantInput.value);
        if(!variant) {submit.disabled=true;return;}
        const plan=variant.plans.find(p=>String(p.id)===planInput.value);
        const compare=variant.compare || variant.price;
        price=plan ? plan.price : variant.price;
        const n=Math.max(1,Math.floor(Number(qty.value)||1));
        syncPurchaseCards(plan);
        $('[data-unit-price]',form).textContent=money(price,data.currency);
        $('[data-purchase-total]',form).textContent=money(price*n,data.currency);
        const crossed=$('[data-compare-price]',form);crossed.textContent=money(compare,data.currency);crossed.hidden=compare<=price;
        $('[data-purchase-terms]',form).textContent=plan ? `${plan.name}. ${money(price,data.currency)} per set, charged each delivery. Manage or cancel using the link in your subscription confirmation email.` : 'One payment. No recurring deliveries.';
        const unavailable=!variant.available || (variant.requires_plan && !plan);
        submit.disabled=busy||unavailable;
        $('[data-add-label]',form).textContent=busy?'Adding…':unavailable?'Sold out':'Add to bag';
        if(form.getAttribute('id')==='pdp-buy'){
          const sticky=$('[data-sticky-price]'),button=$('[data-sticky-submit]');
          if(sticky) sticky.textContent=money(price*n,data.currency);
          if(button){button.disabled=submit.disabled;button.textContent=busy?'Adding…':unavailable?'Sold out':'Add to bag';}
          const terms=$('[data-sticky-terms]');if(terms)terms.textContent=plan?(' / '+(plan.name.match(/every\s+\d+\s+weeks?/i)?.[0]||'delivery')+' · Cancel anytime'):' · One-time';
        }
      };
      function syncPurchaseCards(plan){
        if(!form.hasAttribute('data-pdp-cards'))return;
        const count=Number.parseInt(variant.title,10)||1, firstPlan=variant.plans[0];
        const saving=firstPlan?Math.round((variant.price-firstPlan.price)*100/variant.price):0;

        const bundleValue=form.closest('.tier-card')?.querySelector('[data-bundle-value]');
        if(bundleValue){const shownPrice=plan?plan.price:variant.price,setSaving=Math.max(0,variants[0].price*count-shownPrice);bundleValue.textContent=money(shownPrice/count,data.currency)+' per bottle'+(setSaving?' · Save '+money(setSaving,data.currency):'');}
        $('[data-price-context]',form).textContent=(count===1?'100ml / 3.4 fl oz':count+' × 100ml')+' · '+money((plan?plan.price:variant.price)/(count*100),data.currency)+'/ml';
        $('[data-once-price]',form).textContent=money(variant.price,data.currency);
        $('[data-sub-price]',form).textContent=firstPlan?money((plan||firstPlan).price,data.currency):'';
        $('[data-plan-saving]',form).textContent=saving>0?'Save '+saving+'%':'';
        $('[data-saving-copy]',form).textContent=saving>0?'Save '+saving+'% on every order':'Recurring delivery';
        $('[data-subscribe-card]',form).hidden=!firstPlan;

        $('[data-one-time-card]',form).hidden=variant.requires_plan;
        $$('[name="supply_choice"]',form).forEach(el=>{
          el.checked=el.value===String(variant.id);
          const option=variants.find(v=>String(v.id)===el.value), label=el.closest('label');
          const optionPlan=plan?option?.plans.find(p=>p.name===plan.name):null;
          const optionPrice=optionPlan?.price??option?.price;
          const priceEl=$('[data-supply-price]',label),saveEl=$('[data-supply-saving]',label),compareEl=$('[data-supply-compare]',label);
          if(priceEl)priceEl.textContent=money(optionPrice,data.currency);
          const saving=Math.max(0,(Number.parseInt(option?.title,10)||1)*variants[0].price-optionPrice);
          if(saveEl){saveEl.hidden=!saving;saveEl.textContent='Save '+money(saving,data.currency);}if(compareEl){const qty=Number.parseInt(option?.title,10)||1,singlePlan=plan?variants[0]?.plans?.find(p=>p.name===plan.name):null,basePrice=singlePlan?.price??variants[0]?.price,compareAmt=qty*basePrice;compareEl.hidden=!(compareAmt>optionPrice&&qty>1);compareEl.textContent=money(compareAmt,data.currency);}
        });
        $$('[name="purchase_mode"]',form).forEach(el=>el.checked=el.value===(plan?'subscribe':'once'));
        $('[data-delivery-choices]',form).hidden=!plan;
        const options=$('[data-delivery-options]',form);
        if(options.dataset.variant!==String(variant.id)){
          options.innerHTML=variant.plans.map(p=>{const weeks=p.name.match(/(\d+)\s*weeks?/i);return `<label class="delivery-pill"><input type="radio" name="delivery_choice" value="${escape(p.id)}"><span>${escape(weeks?weeks[1]+' weeks':p.name)}</span></label>`;}).join('');
          options.dataset.variant=String(variant.id);
        }
        $$('[name="delivery_choice"]',form).forEach(el=>el.checked=!!plan&&el.value===String(plan.id));
        const selection=form.getAttribute('id')==='pdp-buy'?$('[data-sticky-selection]'):null;if(selection)selection.textContent=variant.title+' · '+(plan?'Subscribe & save':'One-time purchase');
      }
      if(form.hasAttribute('data-pdp-cards')){
        const params=new URLSearchParams(location.search),requestedPlan=params.get('selling_plan');
        if(requestedPlan&&[...planInput.options].some(o=>o.value===requestedPlan))planInput.value=requestedPlan;
        else if(params.get('purchase')==='once')planInput.value='';
        else if(form.hasAttribute('data-default-subscription')){
          const initial=variants.find(v=>String(v.id)===variantInput.value);
          const fourWeek=initial?.plans.find(p=>/every\s+4\s+weeks?/i.test(p.name));
          if(fourWeek)planInput.value=String(fourWeek.id);
        }
        form.addEventListener('change',e=>{
          if(e.target.name==='supply_choice'){variantInput.value=e.target.value;variantInput.dispatchEvent(new Event('change',{bubbles:true}));}
          if(e.target.name==='purchase_mode'){
            planInput.value=e.target.value==='once'?'':(form.dataset.lastPlan&&variant.plans.some(p=>String(p.id)===form.dataset.lastPlan)?form.dataset.lastPlan:String(variant.plans[0]?.id||''));
            planInput.dispatchEvent(new Event('change',{bubbles:true}));
          }
          if(e.target.name==='delivery_choice'){planInput.value=e.target.value;form.dataset.lastPlan=e.target.value;planInput.dispatchEvent(new Event('change',{bubbles:true}));}
        });
      }
      const changeVariant=()=>{
        const old=planInput.value,oldPlan=variant?.plans.find(p=>String(p.id)===old);
        variant=variants.find(v=>String(v.id)===variantInput.value); if(!variant) return;
        planInput.replaceChildren();
        if(!variant.requires_plan) planInput.add(new Option('One-time purchase — '+money(variant.price,data.currency),''));
        variant.plans.forEach(p=>planInput.add(new Option(p.name+' — '+money(p.price,data.currency),String(p.id))));
        if([...planInput.options].some(o=>o.value===old)) planInput.value=old;
        else if(oldPlan){const matching=variant.plans.find(p=>p.name===oldPlan.name)||variant.plans[0];if(matching)planInput.value=String(matching.id);}
        update();
      };
      variantInput.addEventListener('change',changeVariant);planInput.addEventListener('change',update);qty.addEventListener('input',update);
      qty.addEventListener('change',()=>{qty.value=Math.max(1,Math.floor(Number(qty.value)||1));update();});
      form.addEventListener('submit',async e=>{
        e.preventDefault();if(busy || !form.reportValidity() || !variant?.available) return;
        busy=true;update();const error=$('[data-form-error]',form);error.hidden=true;
        const payload=new FormData(form);['supply_choice','purchase_mode','delivery_choice'].forEach(name=>payload.delete(name));if(!payload.get('selling_plan'))payload.delete('selling_plan');
        let added=false;
        try{await request('cart/add.js',{method:'POST',body:payload});added=true;await syncCart();toast('Added to your bag');openCart();}
        catch(err){if(added){location.href=root+'cart';return;}error.textContent=err.message;error.hidden=false;}
        finally{busy=false;update();}
      });
      changeVariant();
      if(form.getAttribute('id')==='pdp-buy'){
        const sticky=$('[data-sticky-buy]');
        if(sticky){
          let scheduled=false;
          const updateSticky=()=>{
            scheduled=false;
            const rect=form.getBoundingClientRect(),navBottom=$('#site-nav')?.getBoundingClientRect().bottom||60;
            const cookie=$('#shopify-pc__banner') || $('[role="dialog"][aria-label*="cookie" i]');
            const cookieVisible=cookie && cookie.getClientRects().length && getComputedStyle(cookie).visibility!=='hidden';
            const purchaseVisible=rect.top<innerHeight-110&&rect.bottom>navBottom;
            const focused=document.activeElement;
            const typing=focused?.matches('textarea,select,input:not([type=radio]):not([type=checkbox]):not([type=hidden]):not([type=button]):not([type=submit])');
            const visible=!purchaseVisible && !drawer?.classList.contains('open') && !menu?.classList.contains('open') && !document.querySelector('dialog[open]') && !cookieVisible && !typing;
            sticky.hidden=!visible;
            document.body.style.setProperty('--sticky-buy-space',visible?(sticky.offsetHeight+'px'):'0px');
          };
          const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(updateSticky);}};
          window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});
          document.addEventListener('click',schedule);document.addEventListener('focusin',schedule);document.addEventListener('focusout',schedule);
          document.addEventListener('phos:dialog',schedule);
          if('ResizeObserver' in window){const resize=new ResizeObserver(schedule);resize.observe(form);resize.observe(sticky);}
          new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
          updateSticky();
        }
      }
    });
    $$('[data-gallery]',scope).forEach(gallery=>{
      if(gallery.dataset.ready)return;gallery.dataset.ready='true';
      const track=$('[data-gallery-track]',gallery),slides=$$('.pdp-slide',track),count=$('[data-gallery-count]',gallery);
      const index=()=>Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));
      let target=null,selectedIndex=0,settleTimer,previousWidth=track.clientWidth;
      const go=next=>{target=Math.max(0,Math.min(slides.length-1,next));selectedIndex=target;track.scrollTo({left:target*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
      const step=delta=>go((target??index())+delta);
      $('[data-gallery-prev]',gallery).addEventListener('click',()=>step(-1));$('[data-gallery-next]',gallery).addEventListener('click',()=>step(1));
      const thumbs=$$('[data-gallery-index]',gallery);
      thumbs.forEach(button=>button.addEventListener('click',()=>go(Number(button.dataset.galleryIndex))));
      track.addEventListener('pointerdown',()=>{target=null;},{passive:true});
      track.addEventListener('scroll',()=>{if(track.clientWidth!==previousWidth)return;clearTimeout(settleTimer);settleTimer=setTimeout(()=>{target=null;selectedIndex=index();},180);if(target===null)selectedIndex=index();count.textContent=(index()+1)+' / '+slides.length;thumbs.forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.galleryIndex)===index())));const caption=$('[data-gallery-caption]',gallery);if(caption)caption.textContent=slides[index()].querySelector('img').alt;},{passive:true});
      new ResizeObserver(()=>{const width=track.clientWidth;if(!width||width===previousWidth)return;previousWidth=width;target=null;track.scrollTo({left:selectedIndex*width,behavior:'instant'});}).observe(track);
      track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();step(e.key==='ArrowRight'?1:-1);}});
    });
  }
  init();document.addEventListener('shopify:section:load',e=>init(e.target));
  const nav=$('#site-nav');window.addEventListener('scroll',()=>nav?.classList.toggle('nav--scrolled',scrollY>24),{passive:true});
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('in');revealObserver.unobserve(entry.target);}}),{threshold:0.08}) : null;
  $$('.reveal').forEach(el=>{if(revealObserver && !matchMedia('(prefers-reduced-motion: reduce)').matches)revealObserver.observe(el);else el.classList.add('in');});
})();
